import { Delete as DeleteIcon } from '@material-ui/icons';
import { t } from '@lingui/macro';

import { Action } from './Actions';
import { useDashboardContext } from '../dashboard/DashboardContext';
import { useDeleteDialog } from '../../form/DeleteDialog';
import { useDashboardMenu, useMenu } from '../../../stores/DashboardMenuStore';
import { useNavigate } from '../../../utilities/PgmUtilities';
import { useDefaultPage } from '../../side-nav/DefaultPage';
import { useGroupPages, useLandingPage } from '../../../stores/SessionStore';

export default function DeleteDashboardAction(props) {
    const navigate = useNavigate();
    const { dashboard } = useDashboardContext();
    const [, /* Not used */ dashboardMenuActions] = useDashboardMenu();
    const [deleteDialog, showDeleteDialog] = useDeleteDialog(t`Are you sure you want to delete this dashboard?`);
    const { defaultPage } = useDefaultPage();
    const [landingPage] = useLandingPage();
    const [visiblePages] = useGroupPages();
    const [dashboardMenu] = useMenu();

    return (
        <>
            <Action
                icon={<DeleteIcon />}
                tooltip={t`Delete this dashboard`}
                onClick={() => {
                    showDeleteDialog(() => {
                        dashboardMenuActions.deleteDashboard(dashboard);

                        let postDeleteUrl = defaultPage;
                        if (defaultPage.slice(1) === dashboard.id) {
                            postDeleteUrl = landingPage ? `/${landingPage}` : '/sites-overview';
                            if (dashboardMenu?.userDashboards?.length > 1) {
                                const nextDashboardId = dashboardMenu.userDashboards
                                    .filter((userDash) => userDash.id !== dashboard.id)
                                    .at(0).id;
                                postDeleteUrl = `/${nextDashboardId}`;
                            } else {
                                postDeleteUrl = visiblePages.length ? postDeleteUrl : '/no-access';
                            }
                        }

                        navigate(postDeleteUrl);
                    });
                }}
                {...props}
            />
            {deleteDialog}
        </>
    );
}
